//import { fileController } from 'Components/viewer/Controllers/index';
import store from "@/store/index";
import {eSignChinaService} from 'Store/services/index';

/**
 * @typedef {import('Api/bean/FileData.js').FileData} FileData
 */

class PDFViewerService {
  constructor() {
    this.pdfui = null;
  }
  initialize(pdfui) {
    this.pdfui = pdfui;
  }
  /**
   * read buffer from Windows.Storage.StorageFile
   * @param {FileData} fileData
   */
  readStorageFile(file) {
    return new Promise((resolve, reject) => {
      try {
        window.__file0__ = file;
        Windows.Storage.FileIO.readBufferAsync(file)
          .done(function (buffer) {
            //logger('buffer.length:' + buffer.length);
            var bytes = new Uint8Array(buffer.length);
            var dataReader = Windows.Storage.Streams.DataReader.fromBuffer(buffer);
            dataReader.readBytes(bytes);
            dataReader.close();

            // do something with bytes
            resolve(bytes);
          });
      } catch (error) {
        reject(error)
      }

    })
  }
  openStorageFile(file) {
    return this.readStorageFile(file).then((buffer) => {
      return this.openFile(buffer, file.name);
    })
  }
  async openFile(file, fileName, options) {
    try {
      return await this.pdfui.openPDFByFile(file, { fileName, ...options });
    } catch(ex) {
       const stack = new Error().stack;
        let errors = {
          level:'error',
          category:'OpenFile',
          data:{message: `open file error. ${(ex&& ex.message)?ex.message:''}`, errorCode: ex.error, stack}
        }
        store.appStore.doPostError(errors);
        return Promise.resolve();  //Ends here, no more exception handler.
    }
  }
  async openFileUrl(url, fileName){
    let result = await this.pdfui.openPDFByHttpRangeRequest({ range: { url: url }},{fileName});
    return result;
  }
  
  async autoGenerateFieldName(srcFieldType, srcFieldObjNum, pageIndex) {
      const currentDoc = await this.pdfui.getCurrentPDFDoc();
      const pdfForm = currentDoc.PDFForm;
      let page = await currentDoc.getPageByIndex(pageIndex)
      let srcWidget = page.annots.find( annot => annot.objectNumber === srcFieldObjNum)
      return pdfForm.autoGenerateFieldName(srcWidget)
  }
  
  async getFieldPasteType(widgets, pageIndex) {
     if (widgets.length < 1) {
       return;
     } else if (widgets.length > 1) {
         return { pasteFieldType: "pasteControl" }
     } else {
         const { newFieldName, fieldTypeName } = await this.autoGenerateFieldName(widgets[0].type, widgets[0].srcObjectNumber, pageIndex)

         const { isESignCNField } = eSignChinaService.isESignCNField(widgets[0].srcObjectNumber);
         if (isESignCNField) {
             return { pasteFieldType: "createFieldWithCopyControl", newFieldName }
         } else {
             let { pasteFieldType } = store.docStore.formPreference;
             if (pasteFieldType) {
                 return { pasteFieldType, newFieldName }
             } else {
                 let confirmRet = await this.pdfui.customs.confirmPasteFieldDialog(fieldTypeName, newFieldName);
                 return { pasteFieldType: confirmRet.pasteFieldType, newFieldName }
             }
         }
     }
  }
}

export default PDFViewerService;